import gql from 'graphql-tag'

export const CREATE_PRINT = gql`
  mutation createPrint($accreditationId: ID!) {
    createPrint(accreditationId: $accreditationId){
      id
    }
  }`

export const BULK_CREATE_PRINT = gql`
  mutation bulkCreatePrint($id: ID!, $accreditationIds: [ID!]!) {
    bulkCreatePrint(id: $id, accreditationIds: $accreditationIds)
  }`

export const PRINT_ALL = gql`
  mutation printAll($id: ID!) {
    printAll(id: $id)
  }`
